module.exports = __webpack_public_path__ + "static/media/Temp-CWU.8807b1c7.svg";